<template>
  <gensee-video-player
    :auto-play="true"
    :video-id="videoSourceId"
  ></gensee-video-player>
</template>

<script>
import { defineComponent, reactive, toRefs } from '@vue/composition-api'
import GenseeVideoPlayer from '@/components/GenseeVideoPlayer/GenseeVideoPlayer'
import appInfo from '@/assets/js/appInfo'

export default defineComponent({
  name: 'tactics-video',
  components: { GenseeVideoPlayer },
  setup() {
    const state = reactive({
      title: appInfo.getParam('title'),
      videoSourceId: appInfo.getParam('videoSourceId')
    })

    if (state.title) {
      document.title = state.title
    }

    return {
      ...toRefs(state)
    }
  }
})
</script>

<style lang="scss" scoped></style>
